import { useBootup } from '@/hooks/useBootup';
import { KitType } from '@viome/viome-base/src/usecase/Bootup/BootupModel';

/**
 * Reads kit type from `useBootup()` (derived from the active context via
 * Zustand, same as CancerDetect's nav gating) rather than the localStorage
 * mirror — that mirror only refreshes on a consumer's mount, so a component
 * that stays mounted across a context switch (e.g. the sidebar) saw a stale
 * value and PRO-gated surfaces (Shop hide) wouldn't update on switch.
 */
export const useIsProUser = () => {
  const { bootupState } = useBootup();
  const kitType = bootupState?.kitType;
  const preRnRKitType = bootupState?.preRnRKitType;

  return (
    kitType === KitType.PHPRO ||
    kitType === KitType.GHPRO ||
    preRnRKitType === KitType.PHPRO ||
    preRnRKitType === KitType.GHPRO
  );
};
